export class Enterprise {
    public id: number = 0;
    public name: string = '';
    public tenantId: number = null;
    public tenantName?: string = '';
    public glCompanies?: string[] = [];
    public isEnabled :  boolean = true;
}
